import { render } from "./OfflineStores.vue?vue&type=template&id=7d675262"
import script from "./OfflineStores.vue?vue&type=script&lang=js"
export * from "./OfflineStores.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__